import dispatcher from '../modules/dispatcher';

// export const getThreeJs = ({ timeout = 0 }) => {
//     return new Promise(resolve => {
//         if (window.THREE) {
//             resolve(THREE);
//         }
//         else {
//             setTimeout(() => {
//                 import(/* webpackPrefetch: true */ '../libs/THREE')
//                     .then((module) => {
//                         window.THREE = module;
//                         resolve(THREE);
//                     });
//             }, timeout);
//         }
//     });
// };
// Example
// getThreeJs({ timeout: 100 })
//     .then(() => {
//
//     });

export const webpTest = (function() {
    let c = document.createElement('canvas');
    return !!(c.getContext && c.getContext('2d')) ?
        c.toDataURL('image/webp').indexOf('data:image/webp') === 0 :
        false;
})();

export const matchComponent = (name) => {
    return (
      !!document.querySelector(name) ||
      !!document.querySelector('[is="' + name + '"]')
    )
};

export const distComponents = (callback, delay = 0) => {
    setTimeout(callback, delay);
    dispatcher.subscribe(e => {
        if (e.type === "content:replaced")
            callback();
    });
};

export const promiseWithTimer = (promise, ms) => {
    const timer = new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
    return Promise.all([promise, timer]).then((result) => result[0]);
}